import { cn } from "@/lib/utils";
import { warningColors } from "../../utils/warningColors";

interface Props {
    label: string | React.ReactNode;
    info: string | React.ReactNode;
    description?: string;
    noInfo?: boolean;
    /** Use small, dense text to match IconDetail-style rows. */
    compact?: boolean;
    /** One step up from default compact sizing. */
    compactProminent?: boolean;
    /** Override compact info text size (e.g. text-lg for the value only). */
    infoClassName?: string;
}

const RequiredInfo = ({
    label,
    info,
    description,
    noInfo = false,
    compact = false,
    compactProminent = false,
    infoClassName,
}: Props) => {
    const booleanToString = (value: boolean) => (value ? "Yes" : "No");

    const displayInfo =
        info === null || info === undefined || info === ""
            ? "Information Missing"
            : typeof info === "boolean"
              ? booleanToString(info)
              : info;

    const isInfoMissing = !info || noInfo;
    const compactLabelClass = compactProminent ? "text-sm" : "text-xs";
    const compactInfoClass = compactProminent ? "text-base" : "text-sm";

    return (
        <div className={cn("flex flex-col w-full max-w-[calc(100%-80px)]", compact ? "" : "mb-4")}>
            {label && (
                <p
                    className={cn(
                        "p-0 w-full text-left",
                        compact
                            ? cn(compactLabelClass, "font-medium text-muted-foreground uppercase tracking-wide")
                            : cn("font-semibold text-sm", warningColors(isInfoMissing))
                    )}
                >
                    {label}
                </p>
            )}
            {description && <p className="text-slate-600 dark:text-slate-300 text-sm text-left">{description}</p>}
            <div
                className={cn(
                    "p-0 w-full text-left",
                    compact
                        ? cn("mt-1.5", infoClassName ?? compactInfoClass, "text-slate-800 dark:text-slate-200")
                        : cn("text-lg", warningColors(isInfoMissing))
                )}
            >
                {displayInfo}
            </div>
        </div>
    );
};

export default RequiredInfo;
